import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const DownloadCenterContext = createContext({
  openDownloadCenter: () => {},
  registerOpenHandler: () => {}
});

export const DownloadCenterProvider = ({ children }) => {
  const [openHandler, setOpenHandler] = useState(null);

  const registerOpenHandler = useCallback(handler => setOpenHandler(() => handler), []);

  const openDownloadCenter = useCallback(() => {
    if (openHandler) openHandler();
  }, [openHandler]);

  const value = useMemo(() => ({ openDownloadCenter, registerOpenHandler }), [openDownloadCenter, registerOpenHandler]);

  return <DownloadCenterContext.Provider value={value}>{children}</DownloadCenterContext.Provider>;
};

DownloadCenterProvider.propTypes = {
  children: PropTypes.any
};

export const useDownloadCenter = () => useContext(DownloadCenterContext);
